<template>
  <div>
    <PageHeader title="چرا اسکیل آپ" :items="pageHeaderItems" />
    <Loader v-if="loading" />
    <div class="card p-5">
      <Section title="عنوان اصلی">
        <div class="my-2">
          <BaseText v-model="model.title" title="عنوان " placeholder="عنوان " />
        </div>
        <div class="my-2 mb-4">
          <TextAreaInput v-model="model.description" title="توضیحات " placeholder="توضیحات " />
        </div>
      </Section>
      <Section title="ویژگی ها">
        <ImageUploader
          isFile
          style="margin-right: 100px"
          :img="logo1"
          :uploadLoading="logo1Loading"
          title="آیکن مورد نظر را انتحاب نمایید"
          @uploadImage="uploadImage($event, 'logo1')"
          @deleteImage="
            model.logo1 = ''
            logo1 = ''
          "
        />
        <div class="my-2">
          <BaseText v-model="model.title1" title="عنوان " placeholder="عنوان " />
        </div>
        <div class="my-2 mb-4">
          <TextAreaInput v-model="model.description1" title="توضیحات " placeholder="توضیحات " />
        </div>
        <ImageUploader
          isFile
          style="margin-right: 100px"
          :img="logo2"
          :uploadLoading="logo2Loading"
          title="آیکن مورد نظر را انتحاب نمایید"
          @uploadImage="uploadImage($event, 'logo2')"
          @deleteImage="
            model.logo2 = ''
            logo2 = ''
          "
        />
        <div class="my-2">
          <BaseText v-model="model.title2" title="عنوان " placeholder="عنوان " />
        </div>
        <div class="my-2 mb-4">
          <TextAreaInput v-model="model.description2" title="توضیحات " placeholder="توضیحات " />
        </div>
        <ImageUploader
          isFile
          style="margin-right: 100px"
          :img="logo3"
          :uploadLoading="logo3Loading"
          title="آیکن مورد نظر را انتحاب نمایید"
          @uploadImage="uploadImage($event, 'logo3')"
          @deleteImage="
            model.logo3 = ''
            logo3 = ''
          "
        />
        <div class="my-2">
          <BaseText v-model="model.title3" title="عنوان " placeholder="عنوان " />
        </div>
        <div class="my-2 mb-4">
          <TextAreaInput v-model="model.description3" title="توضیحات " placeholder="توضیحات " />
        </div>
      </Section>
      <Toast :title="message" :error="error" :showToast="showToast" />
    </div>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.go(-1)">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="onSubmit">ثبت</b-button>
    </div>
  </div>
</template>
<script>
import fileMannager from '../../../services/file'
import skillUpBannerProvider from '../../../services/skillUp/banner'
import Toast from '../../../components/common/Toast.vue'
import BaseText from '../../../components/common/form/formModules/BaseText.vue'
import PageHeader from '../../../components/layoutComponents/page-header.vue'
import ImageUploader from '../../../components/user/ImageUploader.vue'
import Loader from '../../../components/common/loader.vue'
import TextAreaInput from '../../../components/common/form/formModules/TextAreaInput.vue'
import Section from '../../../components/common/form/Section.vue'

export default {
  components: { PageHeader, Loader, ImageUploader, BaseText, Toast, TextAreaInput, Section },
  data() {
    return {
      model: {
        title: '',
        description: '',
        logo1: '',
        title1: '',
        description1: '',
        logo2: '',
        title2: '',
        description2: '',
        logo3: '',
        title3: '',
        description3: '',
      },
      logo1Loading: false,
      logo2Loading: false,
      logo3Loading: false,
      message: '',
      showToast: false,
      submit: false,
      error: false,
      loading: false,
      logo1: '',
      logo2: '',
      logo3: '',
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت چرا اسکیل آپ', active: true },
      ],
    }
  },
  mounted() {
    this.fetchWhySkillUp()
  },
  methods: {
    async downloadSVG(url) {
      try {
        const response = await fetch(url)
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText)
        }
        const svgText = await response.text()
        return 'data:image/svg+xml;base64,' + btoa(svgText)
      } catch (error) {
        return url
      }
    },
    async onSubmit() {
      this.showToast = false
      this.loading = true
      try {
        await skillUpBannerProvider.changeWhySkillUp({ ...this.model })
        this.message = 'اطلاعات با موفقیت ثبت شد.'
        this.showToast = true
        this.loading = false
      } catch (error) {
        this.message = 'خطایی رخ داده، لطفا مجددا تلاش کنید.'
        this.showToast = false
        this.loading = false
      }
    },
    async uploadImage(e, target) {
      this[`${target}Loading`] = true
      const file = e.target.files[0]
      let formData = new FormData()
      formData.append('ListFiles', file)
      const req = await fileMannager.addFile(formData)
      this[`${target}Loading`] = false
      this.model[target] = req.data.data[0].downloadUrl
      this[target] = await this.downloadSVG(this.model[target])
    },

    async fetchWhySkillUp() {
      const req = await skillUpBannerProvider.getWhySkillUp()
      this.model = req.data.data.output
      this.logo1 = await this.downloadSVG(this.model.logo1)
      this.logo2 = await this.downloadSVG(this.model.logo2)
      this.logo3 = await this.downloadSVG(this.model.logo3)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .labelClass {
  min-width: 100px !important;
}
</style>
